import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { SearchBox as SharedSearchBox } from '@bingads-webui-react/search-box';
import { I18nContext } from '@bingads-webui-react/i18n-context';


const SearchBox = (props) => {
  const [searchQuery, setSearchQuery] = useState('');
  const {
    onSearch,
    searchBoxPlacedHolderText,
    searchBoxAriaLabel,
    query,
  } = props;

  useEffect(() => {
    setSearchQuery(query);
  }, [query]);

  const handleClear = () => {
    setSearchQuery('');
    onSearch('');
  };

  const i18n = useContext(I18nContext);

  return (
    <div className="search-box-container">
      <SharedSearchBox
        onQueryChange={(newQuery) => { setSearchQuery(newQuery); }}
        onSearch={() => onSearch(searchQuery)}
        value={searchQuery}
        placeholder={searchBoxPlacedHolderText}
        ariaLabel={searchBoxAriaLabel}
      />
      <button
        onClick={handleClear}
        className="clear-search iconba iconba-Cancel"
        aria-label={i18n && i18n.getString(_TL_('Clear search'))}
      />
    </div>
  );
};

SearchBox.propTypes = {
  query: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
  searchBoxPlacedHolderText: PropTypes.string.isRequired,
  searchBoxAriaLabel: PropTypes.string.isRequired,
};

SearchBox.defaultProps = {
  query: '',
};

export default SearchBox;
